import { TabsProps, Tabs } from 'antd';

export const ATabs: React.FC<TabsProps> = ({ ...res }) => {
  return <Tabs {...res} />;
};
